import * as THREE from 'three';
import Experience from './Experience.js';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'

export default class Camera {
    constructor() {
        this.experience = Experience.getInstance();
        this.sizes = this.experience.sizes;
        this.scene = this.experience.scene;
        this.canvas = this.experience.canvas;

        this.setInstance();
        this.setControls();
    }

    setInstance() {
        this.instance = new THREE.PerspectiveCamera(75, this.sizes.width / this.sizes.height, 0.1, 1000);
        this.instance.position.z = 5;
        this.scene.add(this.instance);
    }

    setControls() {
        this.controls = new OrbitControls(this.instance, this.canvas)
        this.controls.enableDamping = true


        this.controls.minPolarAngle = Math.PI / 2.2 ; // Lower vertical limit 
        this.controls.maxPolarAngle = Math.PI / 1.8; // Upper vertical limit 

        this.controls.minAzimuthAngle = -Math.PI / 20; // Left rotation limit 
        this.controls.maxAzimuthAngle = Math.PI / 20; // Right rotation limit 

        this.controls.minDistance = 4//4; // Minimum zoom distance
        this.controls.maxDistance = 8; // Maximum zoom distance

        this.controls.enablePan = false;

        this.controls.saveState()
    }

    resize() {
        this.instance.aspect = this.sizes.width / this.sizes.height;
        this.instance.updateProjectionMatrix();
    }

    update() {
        this.controls.update()
    }
}